<template>
	<div>
		<Modal v-model="modal.ifShow" :title="modal.Title" width="30%" :mask-closable="false" :closable="false">
			<div>
				<Tree :show-checkbox='true' style="text-align: left;" :data="Menus" ref="tree"></Tree>
			</div>
			<div slot="footer">
				<Button type="warning" @click="modalOk('cancle')" size="large">取消</Button>
				<Button type="success" @click="modalOk('up')" size="large">确认</Button>
			</div>
		</Modal>
	</div>
</template>

<script>
	import {
		mapState,
		mapGetters,
		mapActions
	} from 'vuex'
	import dateFormat from '../../../../../public/js/comm.js'
	import webapi from '../../../../webapi.js';
	export default {
		data() {
			return {
				modal: {
					Title: "用户添加",
					type: "add",
					ifShow: false,
					canInput: false
				},
				Menus: [],
				// Menus: [
				//         {
				//             "Id": 1,
				//             "title": "运营总览",
				//             "ParentId": 0,
				//             "children": [
				//                 {
				//                     "Id": 101,
				//                     "title": "场站总览",
				//                     "ParentId": 0,
				//                     "checked": false
				//                 },
				//                 {
				//                     "Id": 102,
				//                     "title": "营收概况",
				//                     "ParentId": 0,
				//                     "checked": false
				//                 }
				//             ],
				//             "checked": false
				//         },
				//         {
				//             "Id": 2,
				//             "title": "运营管理",
				//             "ParentId": 0,
				//             "children": [
				//                 {
				//                     "Id": 201,
				//                     "title": "场站监控",
				//                     "ParentId": 0,
				//                     "children": [
				//                         {
				//                             "Id": 20101,
				//                             "title": "设备状态",
				//                             "ParentId": 0,
				//                             "children": [
				//                                 {
				//                                     "Id": 1005,
				//                                     "title": "查询",
				//                                     "ParentId": 0,
				//                                     "checked": true,
				//                                 },
				//                                 {
				//                                     "Id": 1007,
				//                                     "title": "增加",
				//                                     "ParentId": 0,
				//                                     "checked": true
				//                                 }
				//                             ],
				//                             "checked": false
				//                         },
				//                         {
				//                             "Id": 20102,
				//                             "title": "收入监控",
				//                             "ParentId": 0,
				//                             "children": [
				//                                 {
				//                                     "Id": 1006,
				//                                     "title": "查询",
				//                                     "ParentId": 0,
				//                                     "checked": true
				//                                 }
				//                             ],
				//                             "checked": false
				//                         },
				//                         {
				//                             "Id": 20103,
				//                             "title": "用电监控",
				//                             "ParentId": 0,
				//                             "checked": false
				//                         },
				//                         {
				//                             "Id": 1001,
				//                             "title": "查询",
				//                             "ParentId": 0,
				//                             "checked": true
				//                         }
				//                     ],
				//                     "checked": false
				//                 },
				//                 {
				//                     "Id": 202,
				//                     "title": "充电监控",
				//                     "ParentId": 0,
				//                     "children": [
				//                         {
				//                             "Id": 20201,
				//                             "title": "实时充电",
				//                             "ParentId": 0,
				//                             "checked": false
				//                         },
				//                         {
				//                             "Id": 20202,
				//                             "title": "实时告警",
				//                             "ParentId": 0,
				//                             "checked": false
				//                         }
				//                     ],
				//                     "checked": false
				//                 },
				//                 {
				//                     "Id": 203,
				//                     "title": "地图监控",
				//                     "ParentId": 0,
				//                     "checked": false
				//                 }
				//             ],
				//             "checked": false
				//         },
				//         {
				//             "Id": 3,
				//             "title": "订单管理",
				//             "ParentId": 0,
				//             "children": [
				//                 {
				//                     "Id": 301,
				//                     "title": "订单记录",
				//                     "ParentId": 0,
				//                     "children": [
				//                         {
				//                             "Id": 30101,
				//                             "title": "充电订单",
				//                             "ParentId": 0,
				//                             "checked": false
				//                         },
				//                         {
				//                             "Id": 30102,
				//                             "title": "互联互通订单",
				//                             "ParentId": 0,
				//                             "checked": false
				//                         },
				//                         {
				//                             "Id": 30103,
				//                             "title": "无效订单",
				//                             "ParentId": 0,
				//                             "checked": false
				//                         },
				//                         {
				//                             "Id": 30104,
				//                             "title": "异常订单",
				//                             "ParentId": 0,
				//                             "checked": false
				//                         }
				//                     ],
				//                     "checked": false
				//                 },
				//                 {
				//                     "Id": 302,
				//                     "title": "离线卡记录",
				//                     "ParentId": 0,
				//                     "checked": false
				//                 }
				//             ],
				//             "checked": false
				//         },
				//         {
				//             "Id": 4,
				//             "title": "统计分析",
				//             "ParentId": 0,
				//             "children": [
				//                 {
				//                     "Id": 401,
				//                     "title": "运营分析",
				//                     "ParentId": 0,
				//                     "children": [
				//                         {
				//                             "Id": 40101,
				//                             "title": "场站分析",
				//                             "ParentId": 0,
				//                             "checked": false
				//                         }
				//                     ],
				//                     "checked": false
				//                 },
				//                 {
				//                     "Id": 402,
				//                     "title": "效率分析",
				//                     "ParentId": 0,
				//                     "children": [
				//                         {
				//                             "Id": 40201,
				//                             "title": "在线率",
				//                             "ParentId": 0,
				//                             "checked": false
				//                         },
				//                         {
				//                             "Id": 40202,
				//                             "title": "利用率",
				//                             "ParentId": 0,
				//                             "checked": false
				//                         },
				//                         {
				//                             "Id": 40203,
				//                             "title": "损耗率",
				//                             "ParentId": 0,
				//                             "checked": false
				//                         }
				//                     ],
				//                     "checked": false
				//                 }
				//             ],
				//             "checked": false
				//         },
				//         {
				//             "Id": 5,
				//             "title": "运维服务",
				//             "ParentId": 0,
				//             "children": [
				//                 {
				//                     "Id": 501,
				//                     "title": "告警记录",
				//                     "ParentId": 0,
				//                     "checked": false
				//                 }
				//             ],
				//             "checked": false
				//         },
				//         {
				//             "Id": 6,
				//             "title": "会员中心",
				//             "ParentId": 0,
				//             "children": [
				//                 {
				//                     "Id": 601,
				//                     "title": "个人会员管理",
				//                     "ParentId": 0,
				//                     "children": [
				//                         {
				//                             "Id": 60101,
				//                             "title": "会员信息",
				//                             "ParentId": 0,
				//                             "checked": false
				//                         },
				//                         {
				//                             "Id": 60102,
				//                             "title": "会员交易记录",
				//                             "ParentId": 0,
				//                             "checked": false
				//                         }
				//                     ],
				//                     "checked": false
				//                 },
				//                 {
				//                     "Id": 602,
				//                     "title": "集团会员管理",
				//                     "ParentId": 0,
				//                     "children": [
				//                         {
				//                             "Id": 60201,
				//                             "title": "集团信息",
				//                             "ParentId": 0,
				//                             "checked": false
				//                         },
				//                         {
				//                             "Id": 60202,
				//                             "title": "集团交易记录",
				//                             "ParentId": 0,
				//                             "checked": false
				//                         }
				//                     ],
				//                     "checked": false
				//                 }
				//             ],
				//             "checked": false
				//         },
				//         {
				//             "Id": 7,
				//             "title": "档案管理",
				//             "ParentId": 0,
				//             "children": [
				//                 {
				//                     "Id": 701,
				//                     "title": "场站管理",
				//                     "ParentId": 0,
				//                     "checked": false
				//                 },
				//                 {
				//                     "Id": 702,
				//                     "title": "设备管理",
				//                     "ParentId": 0,
				//                     "checked": false
				//                 },
				//                 {
				//                     "Id": 703,
				//                     "title": "价格管理",
				//                     "ParentId": 0,
				//                     "checked": false
				//                 },
				//                 {
				//                     "Id": 704,
				//                     "title": "事件管理",
				//                     "ParentId": 0,
				//                     "checked": false
				//                 },
				//                 {
				//                     "Id": 705,
				//                     "title": "优惠券管理",
				//                     "ParentId": 0,
				//                     "checked": false
				//                 },
				//                 {
				//                     "Id": 709,
				//                     "title": "运营商管理",
				//                     "ParentId": 0,
				//                     "checked": false
				//                 }
				//             ],
				//             "checked": false
				//         },
				//         {
				//             "Id": 99,
				//             "title": "系统管理",
				//             "ParentId": 0,
				//             "children": [
				//                 {
				//                     "Id": 9901,
				//                     "title": "个人信息",
				//                     "ParentId": 0,
				//                     "checked": false
				//                 },
				//                 {
				//                     "Id": 9902,
				//                     "title": "权限管理",
				//                     "ParentId": 0,
				//                     "children": [
				//                         {
				//                             "Id": 990201,
				//                             "title": "角色管理",
				//                             "ParentId": 0,
				//                             "checked": false
				//                         },
				//                         {
				//                             "Id": 990202,
				//                             "title": "用户管理",
				//                             "ParentId": 0,
				//                             "checked": false
				//                         }
				//                     ],
				//                     "checked": false
				//                 },
				//                 {
				//                     "Id": 9904,
				//                     "title": "菜单管理",
				//                     "ParentId": 0,
				//                     "checked": false
				//                 },
				//                 {
				//                     "Id": 9905,
				//                     "title": "控件管理",
				//                     "ParentId": 0,
				//                     "checked": false
				//                 }
				//             ],
				//             "checked": false
				//         }
				//     ],
				//添加会员model
				modalInfo: {
					// Id
					// 角色名字
					// 角色描述
					// 操作者Id
					"Id": 0,
					"RoleName": "Test",
					"RoleDesc": "Test2",
					"OperatorId": ''
				},
				currentRole: 0,
				zindex: 2000,
			};
		},
		mounted() {},
		methods: {
			//打开新增会员
			show: function(type, params) {
				const _this = this;
				if (type == "Menu") {
					this.getMenus(params);
					_this.modal.Title = "权限分配";
					_this.modal.type = "Menu";
					_this.currentRole = params
				}
				_this.modal.ifShow = true
			},
			//model操作
			modalOk: function(type) {
				const _this = this
				switch (type) {
					case 'cancle':
						_this.modal.ifShow = false
						break;
					case 'up':
						_this.modal.ifShow = true
						_this.addAndUp('up');
						break;
					default:
						break;
				}
			},
			//添加
			addAndUp: function(type) {
				const _this = this;
				let roleArr = _this.dealMenu();
				if (roleArr.length == 0) {
					_this.$Message.error("请选择菜单以及至少查看控件")
				} else {
					let parms = {
						RoleId: _this.currentRole,
						List: roleArr
					}
					_this.$axios.post(webapi.base_api_url + "/System/AddRolePermission", parms, {}).then(res => {
						console.log("菜单权限")
						console.log(res.data)
						if (res.data.Code == 0) {
							this.$Message.success('菜单权限添加成功');
							_this.modalOk("cancle")
						} else {
							this.$Message.error(res.data.Msg + "---" + res.data.Data);
						}
					})
				}
			},
			getMenus: function(RoleId) {
				this.$axios.post(webapi.base_api_url + "/System/GeRoleMenus", {
					RoleId: RoleId
				}).then(res => {
					if (res.data.Code == 0) {
						this.Menus = res.data.Data.List
					}
				})
			},
			dealMenu: function(Menu) {
				let arr = []
				this.$refs.tree.getCheckedNodes().forEach(item => {
					if (item.children == undefined) {
						arr.push(item.Id)
					}
				})
				return arr;
			},
		},
		computed: {
			//直接选属性
			...mapState({
				StationList: 'Stations',
				RoleList: 'roleList',
				OperatortypeList: 'typeList'
			})
		}
	}
</script>

<style>
</style>
